import { render, staticRenderFns } from "./DocumentBlockMiniViewer.vue?vue&type=template&id=143eda3c&scoped=true&"
import script from "./DocumentBlockMiniViewer.vue?vue&type=script&lang=js&"
export * from "./DocumentBlockMiniViewer.vue?vue&type=script&lang=js&"
import style0 from "./DocumentBlockMiniViewer.vue?vue&type=style&index=0&id=143eda3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143eda3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCol,VDivider,VIcon})
